export enum CommissionMode {
  HT_HT = "ht_ht",
  HT_TTC = "ht_ttc",
  TTC_TTC = "ttc_ttc",
}
